interface Store<T> {
  name: T;
  link: string;
}

interface StoreDisplay<T> {
  ios: Store<T>[];
  android: Store<T>[];
  web: Store<T>[];
}

type DatingStoreName = (typeof datingStores)[number]['name'];

export const datingStores = [
  {
    name: 'App Store',
    link: 'https://trk.mail.ru/c/iflwp5',
  },
  {
    name: 'Google Play',
    link: 'https://trk.mail.ru/c/ymh0l5',
  },
  {
    name: 'RuStore',
    link: 'https://trk.mail.ru/c/tekcx4',
  },
  {
    name: 'Galaxy Store',
    link: 'https://trk.mail.ru/c/v2uzy3',
  },
  {
    name: 'Huawei AppGallery',
    link: 'https://trk.mail.ru/c/skcc89',
  },
  {
    name: 'Xiaomi GetApps',
    link: 'https://trk.mail.ru/c/alumc8',
  },
];

function buildStores<T extends string>(stores: Store<T>[], selectNames: T[]) {
  return stores.filter((store) => selectNames.includes(store.name as T));
}

export const storesDisplayVKDating: StoreDisplay<DatingStoreName> = {
  ios: buildStores(datingStores, ['App Store']),
  android: buildStores(datingStores, ['Google Play', 'RuStore', 'Galaxy Store', 'Huawei AppGallery', 'Xiaomi GetApps']),
  web: buildStores(datingStores, [
    'App Store',
    'Google Play',
    'RuStore',
    'Galaxy Store',
    'Huawei AppGallery',
    'Xiaomi GetApps',
  ]),
};

export const LOADING_DELAY_MS = 500;
